import { Grid } from '@mui/material';
import { FormInput } from '../../components/hook-form/form-input.component';
import { DateFormat, FormDateField } from '../../components/hook-form/form-date.field.component';
import { FileUploadInput } from '../../components/hook-form/file-upload-input-button.component';
import { BorderStyleRounded } from '@mui/icons-material';
import { Contract } from '../../models/contract';

const styling = {
  dropZone: {
    padding: '27px',
    border: '0.1em dashed #99A3A4',
    backgroundColor: '#F2F3F4',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  iconButtonStyle: {
    padding: '15px',
  },
  iconStyle: { width: '40px', height: '40px' },
};

interface ContractFormProps {
  getRootProps: any;
  getInputProps: any;
  isDragActive: any;
  files: any;
  contract?: Contract;
}

export const ContractForm = ({ getRootProps, getInputProps, isDragActive, files, contract }: ContractFormProps) => {
  return (
    <Grid container spacing={2} sx={{ p: 0, m: 0 }}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={6} sm={6} xl={6} xs={6}>
            <FormInput name="contractName" label="Contract Name" autoFocus />
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={6} sm={6} xl={6} xs={6}>
                <FormDateField label="Start Date" name="contractStartDate" required format={DateFormat.SIMPLE_DATE} />
              </Grid>
              <Grid item lg={6} sm={6} xl={6} xs={6}>
                <FormDateField
                  label="End Date"
                  name="contractEndDate"
                  format={DateFormat.SIMPLE_DATE}
                  dateLimits={{ minDateEnabled: true, minDateValue: 'contractStartDate' }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            {/* <FileUploadInput name="contractFiles" /> */}
            <div style={styling.dropZone} {...getRootProps()}>
              <input {...getInputProps()} />
              {!files ? (
                !contract?.fileName ? (
                  isDragActive ? (
                    <p>Drop the files here ...</p>
                  ) : (
                    <div>
                      {files ? (
                        <p>{`${files.name} are selected to upload`}</p>
                      ) : (
                        <p>Drag and drop a file here, or click to select a file</p>
                      )}
                    </div>
                  )
                ) : (
                  contract?.fileName
                )
              ) : (
                <p>{`${files.name} are selected to upload`}</p>
              )}
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
